// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__szjne","count":"styles_count__DdtNv","headerText":"styles_headerText__1bgzb","createButton":"styles_createButton__3iUne"};